import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { useGlobal } from '../contexts/global';
import RegulamentoSP from '../content/legal/sao-paulo/RegulamentoSP';
import RegulamentoBH from '../content/legal/belo-horizonte/RegulamentoBH';
import resolverCidadeSlug from '../utils/cidadeAtiva';
import '../assets/scss/components/Regulamento.scss';

const Regulamento = ({ cidade }) => {
  const modal = useRef();
  const history = useHistory();
  const { setShowRegulamento } = useGlobal();

  const cidadeSlug = resolverCidadeSlug(
    cidade,
    history && history.location ? history.location.pathname : ''
  );

  const back = (e) => {
    e.stopPropagation();
    setShowRegulamento(false);
  };

  const handleModal = (e) => {
    if (modal.current !== null && modal.current !== undefined) {
      if (!modal.current.contains(e.target)) {
        back(e);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleModal);
    return () => {
      document.removeEventListener('mousedown', handleModal);
    };
  }, []);

  return (
    <div className="wrapper-regulamento">
      <div className="modal" ref={modal}>
        <div className="container">
          {cidadeSlug === 'belo-horizonte' ? (
            <RegulamentoBH />
          ) : (
            <RegulamentoSP />
          )}
          <div className="actions">
            <button type="button" onClick={back}>
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

Regulamento.propTypes = {
  cidade: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      slug: PropTypes.string
    })
  ])
};

Regulamento.defaultProps = {
  cidade: null
};

export default Regulamento;
